var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{staticClass:"message",attrs:{"show":_vm.dismissCountDown,"color":_vm.type,"fade":""},on:{"update:show":function($event){_vm.dismissCountDown=$event}}},[_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }